import Polyglot from 'node-polyglot'
import en from 'copy/en'

const polyglot = new Polyglot()
const languages = {en}

export function setLanguage(lang: string) {
	polyglot.clear()
	polyglot.locale(lang)
	polyglot.extend(languages[lang])
}

export function getLanguage() {
	return polyglot.locale()
}

export function t(key: string, vars = null) {
	return polyglot.t(key, vars)
}

export function hasT(key: string) {
	return polyglot.has(key)
}
